import { format, parseISO } from 'date-fns'
import rehypeStringify from 'rehype-stringify'
import remarkParse from 'remark-parse'
import remarkRehype from 'remark-rehype'
import { unified } from 'unified'

export const formattedDate = (date: string) => format(parseISO(date), 'PP')

export const truncate = (str: string, maxLength: number) =>
  str.length > maxLength ? `${str.slice(0, maxLength - 1)}…` : str

const buildProcessor = () =>
  unified().use(remarkParse).use(remarkRehype).use(rehypeStringify)

const mdToHtml = (text: string): string =>
  buildProcessor().processSync(text).toString()

const removeTags = (text: string): string => text.replace(/<[^>]+>/g, '')

export const parseText = (text: string): string => removeTags(mdToHtml(text))
